<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Outras Opções</h1>
        <paragrafo>
          Para pesquisar informações sobre um ingresso, basta clicar na barra de
          pesquisa “Código do Produto” e abrir a opção de Qr Code (sinalizada
          abaixo em vermelho).
        </paragrafo>
        <v-row justify="center">
          <imagem :src="image_5" />
        </v-row>
        <paragrafo>Leia o código do ingresso e o resultado será: </paragrafo>
        <v-row justify="center">
          <imagem :src="image_6" />
        </v-row>
        <paragrafo
          >Tendo o código do ingresso é possível consultar informações ou
          validá-lo diretamente. Abaixo tela <negrito>“Consultar”</negrito>:
        </paragrafo>
        <v-row justify="center">
          <imagem :src="image_7" />
        </v-row>
        <paragrafo
          >A opção de relatórios possui um filtro simples de produto e data, ele
          contém informações sobre o total de ingressos vendidos, portanto
          ingressos à validar. Também o número de ingressos que já foram
          validados (em vermelho).
        </paragrafo>
        <v-row justify="center">
          <imagem :src="image_8" />
        </v-row>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "OutrasOpt",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem_pos.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_5: "/appValidador/validador/validador5.png",
      image_6: "/appValidador/validador/validador6.png",
      image_7: "/appValidador/validador/validador7.png",
      image_8: "/appValidador/validador/validador8.png",
    };
  },
};
</script>
